// Account routes
// Corresponds to config/routes/account.rb

export const accountVerifiesNewPath = (params?: {
  category?: string;
  sourceId?: string;
  return_to?: string;
  bookmarkPayload?: string | null;
}): string => {
  const basePath = "/account/verifies/new";
  if (!params) return basePath;

  const queryParams = new URLSearchParams();
  if (params.category) queryParams.set("category", params.category);
  if (params.sourceId) queryParams.set("source_id", params.sourceId);
  if (params.return_to) queryParams.set("return_to", params.return_to);
  if (params.bookmarkPayload)
    queryParams.set("bookmark_payload", params.bookmarkPayload);

  const queryString = queryParams.toString();
  return queryString ? `${basePath}?${queryString}` : basePath;
};

export const accountLogoutPath = (): string => "/account/logout";

export const accountProfileEditPath = (): string => "/account/profile/edit";

export const mypageRootPath = (): string => "/mypage/";

export const mypageRedirectMagazineArticlesPath = (): string =>
  "/mypage/redirects/magazine_articles";

export const mypageBookmarksPath = (): string => "/mypage/bookmarks";

export const mypageBookmarkPostsPath = (): string => "/mypage/bookmarks/posts";

export const mypageBookmarkStylesPath = (): string =>
  "/mypage/bookmarks/styles";

export const mypageBookmarkArticlesPath = (): string =>
  "/mypage/bookmarks/articles";

export const mypageBookmarkSalonsPath = (): string =>
  "/mypage/bookmarks/salons";

export const mypagePendingBookmarksPath = (): string => "/mypage/bookmarks";

/** @deprecated Use mypageBookmarksPath instead */
export const mypageFavoritesPath = (): string => mypageBookmarksPath();

/** @deprecated Use mypageBookmarkArticlesPath instead */
export const mypageFavoriteArticlesPath = (): string =>
  mypageBookmarkArticlesPath();

export const mypageReservationsPath = (): string => "/mypage/reservations/";

export const mypageReservationPath = (reservationId: string | number): string =>
  `/mypage/reservations/${reservationId}`;

export const mypageTicketsPath = (): string => "/mypage/tickets/";

export const mypageTicketPath = (ticketId: string | number): string =>
  `/mypage/tickets/${ticketId}`;

export const mypageResumesPath = (): string => "/mypage/resumes";

export const mypageResumesNewPath = (): string => "/mypage/resumes/new";

export const mypageResumePath = (resumeId: string | number): string =>
  `/mypage/resumes/${resumeId}`;

export const mypageLogoutPath = (): string => "/mypage/logout";

export const mypageFeedbackPath = (): string => "/mypage/feedback";
